import React from 'react';

const IndustryFocusSection = () => {
  return (
    <section className="industry-focus">
      <div className="container-lg inner-container">
        <h6>Industry Focus</h6>
        <div className="row">
          <div className="col-lg-6">
            <h3 className="b2b-dig-mark">Industries We Propel with <span className="c-primary1">B2B Digital Marketing Excellence</span></h3>
          </div>
        </div>
        <div className="teching-b2b text-white">
          <h4><i>Teching</i> your B2B marketing to new heights.</h4>
          <p className="lsp">In the B2B Technology industry, marketing needs to be as innovative as the solutions it promotes. At Purplepatch, we specialize in catapulting tech businesses into the spotlight. We are not just another marketing agency; we are based in
            Silicon Valley, and we live and breathe tech daily. We bring a blend of industry-specific knowledge and creative marketing techniques to the table, ensuring your solutions shine in a crowded marketplace. By partnering with us, you
            gain access to marketing strategies that are not only data-driven but also finely tuned to the nuances of the B2B tech industry.</p>

          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="sm-media">
                <a href="#" className="res-a"></a>
                <div className="sm-media-icon icon-list featured-success">

                </div>
                <div className="sm-media-text">
                  <p>Featured Success Stories</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="sm-media">
                <a href="#" className="res-a"></a>
                <div className="sm-media-icon icon-list resource-downloads">

                </div>
                <div className="sm-media-text">
                  <p>Resource Downloads</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="sm-media">
                <a href="#" className="res-a"></a>
                <div className="sm-media-icon icon-list client-testimonials">

                </div>
                <div className="sm-media-text">
                  <p>Client Testimonials</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryFocusSection;
